import { Button } from "@/components/ui/button";

/**
 * "Continue with Google" button. Routes through our own /api/auth/google/start
 * endpoint which server-side redirects to the upstream OAuth provider — this
 * keeps the third-party URL out of the app bundle / DOM.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton({ label = "Continue with Google", dataTestid = "google-signin", className = "" }) {
  const go = () => {
    // Land users in /app after Google finishes.
    const redirectUrl = window.location.origin + "/app";
    const api = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${api}/api/auth/google/start?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button
      type="button"
      onClick={go}
      data-testid={dataTestid}
      className={`btn-pill w-full h-12 bg-[var(--rm-surface)] border border-[var(--rammy-border)] text-[var(--rammy-text)] hover:bg-[var(--rammy-surface-alt)] ${className}`}
    >
      <GoogleIcon />
      <span className="ml-2 font-medium">{label}</span>
    </Button>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.06 12.25c0-.85-.08-1.67-.22-2.45H12v4.63h6.19c-.27 1.43-1.07 2.63-2.28 3.44v2.86h3.68c2.15-1.98 3.47-4.9 3.47-8.48z"/>
      <path fill="#34A853" d="M12 24c3.08 0 5.66-1.02 7.55-2.77l-3.68-2.86c-1.02.68-2.33 1.09-3.87 1.09-2.98 0-5.5-2.01-6.4-4.71H1.83v2.95C3.71 21.36 7.55 24 12 24z"/>
      <path fill="#FBBC05" d="M5.6 14.75c-.23-.68-.36-1.4-.36-2.15s.13-1.47.36-2.15V7.5H1.83A11.99 11.99 0 0 0 .55 12c0 1.94.46 3.77 1.28 5.4l3.77-2.65z"/>
      <path fill="#EA4335" d="M12 4.75c1.68 0 3.19.58 4.38 1.71l3.28-3.28C17.66 1.19 15.08 0 12 0 7.55 0 3.71 2.64 1.83 6.5l3.77 2.95c.9-2.7 3.42-4.7 6.4-4.7z"/>
    </svg>
  );
}
